var React = require('react');

function Search2025 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.13859 13.2772C10.5288 13.2772 13.2772 10.5288 13.2772 7.13859C13.2772 3.74834 10.5288 1 7.13859 1C3.74834 1 1 3.74834 1 7.13859C1 10.5288 3.74834 13.2772 7.13859 13.2772Z","stroke":"black","strokeWidth":"1.69987","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.2657 11.0637C11.9337 10.7318 11.3956 10.7319 11.0637 11.0639C10.7318 11.3959 10.7319 11.934 11.0639 12.2659L11.6648 11.6648L12.2657 11.0637ZM11.6648 11.6648L11.0639 12.2659L17.4013 18.6011L18.0022 18L18.6031 17.3989L12.2657 11.0637L11.6648 11.6648Z","fill":"black","key":1})]);
}

Search2025.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Search2025;

Search2025.default = Search2025;
